{
  "screens": {
    "PORTRAIT_TOUCH": {
      "name": "10.4\" portrait display",
      "extraInfo": "768 x 1024 pixels, Portrait orientation"
    },
    "DOUBLE_TOUCH": {
      "name": "21.5\" split display",
      "extraInfo": "1080 x 1920 pixels, Portrait orientation"
    },
    "EXTRA_LARGE_TOUCH": {
      "name": "21.5\" full display",
      "extraInfo": "1080 x 1920 pixels, Portrait orientation"
    },
    "COLOUR_TOUCH": {
      "name": "10.5\" landscape display",
      "extraInfo": "752 x 423 pixels"
    },
    "SMALL_COLOUR": {
      "name": "8.6\" display",
      "extraInfo": "No touch"
    },
    "UNO": {
      "name": "15\" display",
      "extraInfo": "976 x 549 pixels"
    }
  },
  "media": {
    "IDLE": {
      "name": "Idle screen",
      "extraInfo": "This media is shown while the machine is not being used and is the screen users will see when approaching the machine."
    },
    "WAIT": {
      "name": "Receipt screen",
      "extraInfo": "This media is shown while the receipt is printing until the user takes the receipt."
    },
    "IDLE_DOUBLE_BOTTOM": {
      "name": "Idle screen (split)",
      "extraInfo": "This media is shown on the bottom part of split displays, while the machine is not being used and is the screen users will see when approaching the machine."
    },
    "DOUBLE_TOP": {
      "name": "Top screen",
      "extraInfo": "This media is shown on the top part of split displays, both in the idle- and receipt screens"
    },
    "WAIT_DOUBLE_BOTTOM": {
      "name": "Receipt screen (split)",
      "extraInfo": "This media is shown on the bottom part of split displays, while the receipt is printing until the user takes the receipt."
    },
    "DOUBLE_SCREEN_BORDER": {
      "name": "Border (split)",
      "extraInfo": "This media is used to set a border around the foreground media on split displays"
    },
    "ACCOUNT": {
      "name": "Account screen",
      "extraInfo": "Missing help text"
    },
    "BORDER": {
      "name": "Border",
      "extraInfo": "This media is used to set a border around the foreground media on both the idle- and receipt screens"
    }
  }
}
